import { render, staticRenderFns } from "./video-upload.vue?vue&type=template&id=b3527d3a&scoped=true&"
import script from "./video-upload.vue?vue&type=script&lang=js&"
export * from "./video-upload.vue?vue&type=script&lang=js&"
import style0 from "./video-upload.vue?vue&type=style&index=0&lang=less&"
import style1 from "./video-upload.vue?vue&type=style&index=1&id=b3527d3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3527d3a",
  null
  
)

export default component.exports